import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './components/App.tsx'
import { AppProvider } from './providers/App'

import './index.css'

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<AppProvider>
			<App />
		</AppProvider>
	</StrictMode>
)
